import axios from "axios";

export const getModel = (baseURLModel, modelID, setModel) => {
  axios
    .get(baseURLModel, {
      params: {
        id: modelID,
      },
    })
    .then((response) => {
      setModel(response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
